import withLazyLoad from './with_lazy_load';
import retry from './retry';

export { retry };

export default withLazyLoad;
